import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router';

import ProjectInfos from '../Explore/ProjectInfos'
import ProjectCard from './ProjectCard';
import StackGrid from "react-stack-grid";

import './Home.css';
import '../Yourprojects/Yourprojects.css'
import Create from '../Icons/Create.svg';
import Launch from '../Icons/Launch.svg';
import Julien from '../Icons/julien.png';

class Home extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	user:[]
	    };
	}

	setCurrentRoute(){
		this.props.actions.setCurrentRoute('Explore');
	}

	componentDidMount() {
	    this.setCurrentRoute();
		this.props.actions.getProjects();
		this.props.actions.checkRedirectValue();
	}

	hasBeenRedirect(){
		this.props.actions.hasBeenRedirect();
	}
	

	render() {
		const createItem = (item, index) => {
	    	return <div className="projectCard" key={item.project_id} >
	    			<ProjectInfos current_amount={item.current_amount} 
						target={item.target} 
						privacy={item.privacy}
						project_id={item.project_id}
						currentUser={this.props.currentUser} 
						creator_email={item.creator_email} 
						achieved_at={item.project_achieved_at}
						actions={this.props.actions}
						has_accepted_invite={item.has_accepted_invite} />
					<Link to={'/projects/'+item.project_id} key={item.project_id}>
	    				<ProjectCard 
	    					data={item} 
	    					id={item.project_id} 
	    					key={item.project_id} 
	    					transactions={this.props.transactions} 
	    					currentUser={this.props.currentUser} 
							achieved_at={item.project_achieved_at}
	    					actions={this.props.actions} />
	    			</Link>
				</div>
	    }
		return (
			<div className="container">
				<div className="homeContainer">
					<div className="preFooter">
						<div className="avatar"><img src={Julien} alt="Julien Hervouët" /></div>
						<div className="quoteContainer">
							<div className="quote">
								A few years ago, I received an email from Geoffrey Thomas asking me if he could send some flowers to a customer who was at the hospital.
								<br/>It really clicked! Why would Geoffrey need my authorization for that? His idea was amazing, I trust him. He should be able to decide by himself.
								<br/>The Cagnotte was born from this request. Make it possible for everybody to take initiatives.
								<br/>Since, great individual or team Cagnotte project were born such as : customized treats for a special client, a board game to onboard newbies, Great professional books.
								<br/>150€ per person to let you to contribute to enhancing the image of iAdvize and to turn your ideas into successful projects!
							</div>
						</div>
					</div>
					{!this.props.emptyProjects ?
						<div className="cardsContainer">
							<div className="title">Wild projects that need your help</div>
								<StackGrid
							        columnWidth={250}
							        gutterHeight={20}
							        gutterWidth={20}>
						      	<Link to='/create'>
									<div className="projectCard add">
										<div className="createIcon"><img src={Create} alt="Create your own project" title="Create your own project" /></div>
										<div className="createText">Add a project</div>
									</div>
								</Link>
								{this.props.projects.map(createItem)}
							</StackGrid>
						</div>
					: <div className="cardsContainer empty">
							<div className="title">Create the first Back’on project and get the backing you need!</div>
							<div className="default">
								<div className="illustration">
									<img src={Launch} alt="Create the first project" />
								</div>
								<Link to='/create'>
									<button className="button is-primary">Create a project</button>
								</Link>
							</div>
						</div>
					}
				</div>
				{this.props.connexionUri !== '' && this.props.connexionUri !== '/' && this.props.connexionUri !== false && (
		          <div>
			          <Redirect to={'/' + this.props.connexionUri}/>
			          {this.hasBeenRedirect()}
		          </div>
		        )}
			</div>
		);
	}
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Explore/Home.js